import React from "react";
import Carousel from "./Carousel";

const LandscapeCarousel = () => {
    return <Carousel imageType="landscape" />;
};

export default LandscapeCarousel;
